import { useAuth } from '../contexts/AuthContext'
import type { PropertyDefinition } from '../api/schema'

export function usePropertyExport() {
  const { orgCode, accessToken } = useAuth()

  const exportProperty = async (property: PropertyDefinition) => {
    // Use the types export endpoint with property_uid filter
    try {
      // Build query parameters
      const queryParams = new URLSearchParams()
      queryParams.append('types', 'properties')
      queryParams.append('format', 'json')
      queryParams.append('property_uid', property.uid)

      // Make API call for export using raw fetch since response is a file download
      const token = accessToken || 'pat_demo'
      const apiUrl = `/api/v1/organizations/${orgCode}/types/export?${queryParams.toString()}`
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })

      if (!response.ok) {
        const errorText = await response.text()
        throw new Error(errorText || `HTTP error! status: ${response.status}`)
      }

      // Get JSON data
      const jsonData = await response.json()
      const blob = new Blob([JSON.stringify(jsonData, null, 2)], { type: 'application/json' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url

      // Generate filename with timestamp
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19)
      link.download = `property-export-${property.code}-${timestamp}.json`

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)

    } catch (error) {
      console.error('Export error:', error)
      throw error
    }
  }

  return { exportProperty }
}